// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__224HZ","title":"styles_title__2GyUn"};